import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as CoreActions from '@core/core.actions';
import { Store } from '@ngrx/store';
import { RootState } from '@root/app.state';

@Component({
  selector: 'app-user-authentication-editor',
  templateUrl: './user-authentication-editor.component.html',
  styleUrls: ['./user-authentication-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserAuthenticationEditorComponent {
  @Input() userId: string;
  @Input() changePasswordUrl: string;
  @Input() showResendWelcomeEmail = false;

  constructor(private store$: Store<RootState>) {}
  resendWelcomeMail() {
    this.store$.dispatch(CoreActions.resendWelcomeMail({ userId: this.userId }));
  }
}
